import LocalizedStrings from "react-localization";
import React from "react";

export const LS = new LocalizedStrings({
  fi: {
    manageUsers: {
      username: "* Käyttäjänimi",
      name: "Nimi",
      description: "Kuvaus",
      email: "Sähköposti",
      password: "* Salasana",
      userManagement: "Käyttäjien hallinta",
      addUser: "Lisää uusi käyttäjä",
      changePasswordExpiry: "Vaihda salasanojen vanhenemisaika",
      searchUser: "Hae käyttäjää...",
      expiryYes: "Kyllä, vanhenemisaika kuukausina: ",
      expiryNo: "Ei",
      expiryAllUsers: "Kaikille käyttäjille",
      expiryNewUsers: "Uusille käyttäjille",
      tableActive: "Aktiivinen",
      tableUsername: "Tunnus",
      tableQuickActions: "Pikatoiminnot",
      tableNoSearchResults:
        "Järjestelmässä ei ole yhtään hakuehtoihin sopivaa käyttäjää",
      delete: "Poista",
      edit: "Muokkaa",
      log: "Lokitiedot",
      userPassword: "Käyttäjän salasana",
      userPasswordExpires: "Käyttäjän salasana vanhenee ",
      changeUserPasswordExpiry: "Salasanan vanheneminen",
      changeUserPassword: "Vaihda käyttäjän salasana",
      roles: "Roolit",
      groups: "Ryhmät",
      passiveUser: "Passiivinen käyttäjä",
    },
    manageGroups: {
      addGroup: "Lisää uusi ryhmä",
      groupName: "Ryhmän nimi",
      groupContactEmail: "Ryhmän yhteyssähköposti tiedotteita varten",
      groupResponsable: "Ryhmän vastuuhenkilö",
      groupDescription: "Ryhmän kuvaus",
      groupManagement: "Ryhmien hallinta",
      internalGroups: "Sisäiset ryhmät",
      externalGroups: "Ulkoiset ryhmät",
      externalGroupsHelp: "Ulkoisia ryhmiä voi muokata rajatusti",
      deleteConfirm: "Haluatko varmasti poistaa ryhmän ",
      accessToClassifiedInformation: "Pääsy salassapidettäviin tietoihin",
      delete: "Poista",
      edit: "Muokkaa",
      affectsOtherAccessRights:
        "Muutokset vaikuttavat samoihin kenttiin seuraavissa kohdetyypeissä: ",
      groupData: "Ryhmän tiedot",
      groupUsers: "Ryhmän käyttäjät",
      groupFolders: "Ryhmän oikeudet kansioihin",
      accessRights: "Metatietojen oikeudet",
      read: "Luku",
      write: "Kirjoitus",
      folderName: "Kansion nimi",
      noFolders: "Ryhmällä ei ole oikeuksia kansioihin",
      noUsers: "Ryhmässä ei ole käyttäjiä",
      readSelectAll: "Luku: Valitse kaikki ",
      readSelectNone: "Luku: Poista kaikki valinnat ",
      writeSelectAll: "Kirjoitus: Valitse kaikki ",
      writeSelectNone: "Kirjoitus: Poista kaikki valinnat ",
      AcquisitionInformation: "Hankintaerä",
      Archive: "Arkisto",
      Art: "Taide",
      ImageArchive: "Kuva-arkisto",
      CollectionObject: "Kokoelmaobjekti",
      ProceduralUnits: "Toimenpide",
      SpectrumCollection: "Kokoelma",
      Actor: "Toimija",
      Place: "Paikka",
      Museum: "Museo",
      Location: "Sijaintipaikka",
      Property: "Kiinteistö",
      Area: "Maisemakohde tai Alue",
      ArcheologicalSite: "Arkeologinen kohde",
      BuiltEnvironmentSite: "Rakennetun ympäristön kohde",
      Building: "Rakennus",
      OtherSite: "Muu kohde",
      Project: "Hanke",
      Inspection: "Tarkastus",
      LocalMuseum: "Paikallismuseo",
      Statement: "Lausunto",
      save: "Tallenna",
      cancel: "Peruuta",
      confirmCancel:
        "Sinulla on tallentamattomia muutoksia. Haluatko varmasti palata takaisin?",
    },
    error: {
      invalidFields: "Tallentaminen epäonnistui: Tarkista kentät.",
      objectNoFields: "Objektista ei löytynyt kenttiä.",
      objectLoadFailed: "Objektin lataus epäonnistui.",
      viewCrash:
        "Tapahtui odottamaton virhe. (Lataa sivu uudelleen / Päivitä selaimen välimuisti CTRL+F5)",
      fieldCrash: "Kentän lataaminen epäonnistui.",
      fieldValidation: "Tarkista kenttä.",
      noValues: "Arvoja ei löytynyt.",
      invalidDate: "Päivämäärä väärin. (PP.KK.VVVV)",
    },
    warning: {
      resultLimit:
        "Arvoja saattaa puuttua listasta (liian monta tulosta). Tarkenna hakua.",
      valueLimitReached: "Arvoja on enemmän. Liian monta näytettäväksi.",
    },
    prompt: {
      removeObject: "Haluatko poistaa objektin?",
      removeAcquisition: `Haluatko poistaa hankintaerän?
Kohteella on pakko olla hankintaerä, valitse uusi ennen tallentamista.`,
      removeAttachment: "Haluatko poistaa liitteen?",
      removeImage: "Haluatko poistaa kuvan?",
      removeLink: "Haluatko poistaa linkin?",
      removeReference: "Haluatko poistaa viitteen?",
      removalReason: "Poistamisen syy:",
      editStatement:
        "Lausunnosta on jo luotu PDF-muotoinen dokumentti. Muutokset lausunnossa käytettyihin kenttiin johtavat siihen, että lausunnon pdf-tiedosto poistetaan. Haluatko tallentaa muutokset?",
      massEditOverwriteField:
        "Aikaisemmat arvot korvataan valituissa kentissä lomakkeelle syötetyillä arvoilla. Haluatko jatkaa?",
    },
    actions: {
      close: "Sulje",
      copyObject: "Lisää uusi näillä tiedoilla",
      choose: "Valitse",
      save: "Tallenna",
      send: "Lähetä",
      edit: "Muokkaa",
      add: "Lisää",
      addNew: "Lisää uusi",
      remove: "Poista",
      open: "Avaa",
      search: "Hae",
      addToCart: "Lisää koriin",
      removeFromCart: "Poista korista",
      preview: "Esikatselu",
      create: "Luo",
      link: "Liitä",
    },
    downloadFile: "Lataa tiedosto",
    downloadVideo: "Lataa video",
    targets: "kohdetta",
    deleted: "Poistettu",
    true: "Kyllä",
    false: "Ei",
    required: "Pakollinen",
    loading: "Lataa",
    info: "Ohje",
    image: "Valokuva",
    object: "Esine",
    primaryVersion: "Ensisijainen versio",
    templates: "Pohjat",
    roles: "Roolit",
    parentCollection: "Isäntäkokoelma",
    subCollection: "Alakokoelma",
    primaryNumber: "päänumero",
    subNumber: "alanumero",
    target: "kohde",
    validationFailTitle: "Virheitä kentissä",
    helpMessages: "Kenttien ohjetekstit",
    objectCount: "Luotavien kohteiden määrä",
    modal: {
      closeWindowPrompt: "Haluatko sulkea ikkunan?",
      saveAndCloseResource: "Tallenna ja sulje",
      saveAndCloseSearch: "Liitä ja sulje",
      closeWithoutSaving: "Sulje tallentamatta",
      doNotClose: "Älä sulje",
      changeAttachment: "Vaihda liite",
      addAttachment: "Lisää liite",
      addImage: "Lisää kuva",
      addMedia: "Lisää media",
      changeImage: "Vaihda kuva",
      searchAndLink: "Hae ja liitä",
    },
    map: {
      attribution: "Sisältää Maanmittauslaitoksen aineistoa",
      tooltips: {
        tooltips: {
          placeMarker: "Lisää paikkamerkintä klikkaamalla",
          firstVertex: "Lisää ensimmäinen piste klikkaamalla",
          continueLine: "Klikkaa jatkaaksesi piirtämistä",
          finishLine: "Klikkaa mitä tahansa paikkamerkintää päättääksesi",
          finishPoly: "Klikkaa ensimmäistä paikkamerkintää päättääksesi",
          finishRect: "Klikkaa päättääksesi",
          startCircle: "Lisää ympyrämerkintä klikkaamalla",
          finishCircle: "Klikkaa päättääksesi ympyrän",
          placeCircleMarker: "Lisää ympyrämerkintä klikkaamalla",
        },
        actions: {
          finish: "Lopeta",
          cancel: "Peruuta",
          removeLastVertex: "Poista viimeinen piste",
        },
        buttonTitles: {
          drawMarkerButton: "Lisää paikkamerkintä",
          drawPolyButton: "Lisää monikulmio",
          drawLineButton: "Lisää murtoviiva",
          drawCircleButton: "Lisää ympyrä",
          drawRectButton: "Lisää suorakulmio",
          editButton: "Muokkaa tasoja",
          dragButton: "Siirrä tasoja",
          cutButton: "Leikkaa tasoja",
          deleteButton: "Poista tasoja",
          drawCircleMarkerButton: "Lisää ympyrämerkintä",
          snappingButton:
            "Liitä raahattu paikkamerkintä muihin tasoihin ja pisteisiin",
          pinningButton: "Yhdistä jaetut pisteet",
        },
      },
      buildingIdLabel: "Rakennustunnukset",
    },
    fieldVisibility: {
      type: "Tietueen tyyppi",
      field: "Kenttä",
      changeVisibility: "Muuta kentän näkyvyys",
      saveVisibility: "Tallenna muutokset",
      noFieldChosen: "Yhtään kenttää ei valittuna",
      confirmChangingType: "Hylkää tehdyt muutokset nykyiselle tietuetyypille?",
    },
    statement: {
      presetStatementTexts: "Lausunnon vakiolauseet",
      addPresetStamentText: "Lisää lausunnon vakiolause",
      noPresetStatementTexts: "Lausunnon vakiolauseita ei löytynyt.",
      mailStatement: "Lähetä lausunto",
      statementSolverComment: "Ratkaisijan kommentti",
      sendComment: "Lähetä kommentti",
      massEditRestriction:
        "Massamuokkaukseen valittuihin lausuntoihin liittyy PDF-muotoinen lausunto, jossa käytetyt kentät eivät ole massamuokattavissa eivätkä näy tällä lomakkeella.",
    },
    view: {
      AcquisitionInformation: "Hankintaerä",
      Archive: "Arkisto",
      Art: "Taide",
      ImageArchive: "Kuva-arkisto",
      CollectionObject: "Kokoelmaobjekti",
      ProceduralUnits: "Toimenpide",
      SpectrumCollection: "Kokoelma",
      Actor: "Toimija",
      Place: "Paikka",
      Museum: "Museo",
      LocationInformation: "Sijaintipaikka",
      Property: "Kiinteistö",
      Area: "Maisemakohde tai Alue",
      ArcheologicalSite: "Arkeologinen kohde",
      BuiltEnvironmentSite: "Rakennetun ympäristön kohde",
      Building: "Rakennus",
      OtherSite: "Muu kohde",
      Project: "Hanke",
      Inspection: "Tarkastus",
      LocalMuseum: "Paikallismuseo",
      Statement: "Lausunto",
    },
    messages: {
      uniquenessValidation: {
        template:
          "${Placeholder-object1}, jolla on samat arvot kentissä ${Placeholder-fields}, on jo olemassa. Haluatko varmasti tallentaa ${Placeholder-object2}?",
        fields: {
          Actor: '"etunimi ja sukunimi/nimi/organisaatio"',
          LocationInformation: '"Sijaintipaikan viitenumero tai nimi"',
          Property: '"Kiinteistötunnus"',
          Building: '"Rakennustunnus"',
        },
        object: {
          Actor1: "Toimija",
          Actor2: "toimijan",
          LocationInformation1: "Sijaintipaikka",
          LocationInformation2: "sijaintipaikan",
          Property1: "Kiinteistö",
          Property2: "Kiinteistön",
          Building1: "Rakennus",
          Building2: "Rakennuksen",
        },
      },
    },
  },
  en: {
    manageUsers: {
      username: "* Username",
      name: "Name",
      description: "Description",
      email: "Email",
      password: "* Password",
      userManagement: "User management",
      addUser: "Add new user",
      changePasswordExpiry: "Change password expiry",
      searchUser: "Search user...",
      expiryYes: "Yes, expiry in months: ",
      expiryNo: "No",
      expiryAllUsers: "All users",
      expiryNewUsers: "New users",
      tableActive: "Active",
      tableUsername: "Login",
      tableQuickActions: "Quick actions",
      tableNoSearchResults: "No matching users in system",
      delete: "Delete",
      edit: "Edit",
      log: "Log",
      userPassword: "User's password",
      userPasswordExpires: "User password expires in ",
      changeUserPasswordExpiry: "Password expiry",
      changeUserPassword: "Change user password",
      roles: "Roles",
      groups: "Groups",
      passiveUser: "Passive user",
    },
    manageGroups: {
      addGroup: "Add new group",
      groupName: "Group name",
      groupContactEmail: "Group contact email",
      groupResponsable: "Group responsable",
      groupDescription: "Group description",
      groupManagement: "Group management",
      internalGroups: "Internal groups",
      externalGroups: "External groups",
      externalGroupsHelp: "External groups edit is restricted",
      deleteConfirm: "Do you really want to delete the group ",
      accessToClassifiedInformation: "Access to classified information",
      delete: "Delete",
      edit: "Edit",
      affectsOtherAccessRights: "Modifications affect same fields in: ",
      groupData: "Group data",
      groupUsers: "Group users",
      groupFolders: "Group rights to folders",
      accessRights: "Access rights to metadata",
      read: "Read",
      write: "Write",
      folderName: "Folder name",
      noFolders: "Group does not have rights to any folders",
      noUsers: "Group does not have any users in it",
      readSelectAll: "Read: Select all ",
      readSelectNone: "Read: Select none ",
      writeSelectAll: "Write: Select all ",
      writeSelectNone: "Write: Select none ",
      AcquisitionInformation: "Acquisition Information",
      Archive: "Archive",
      Art: "Art",
      ImageArchive: "Image Archive",
      CollectionObject: "Collection Object",
      ProceduralUnits: "Procedular Unit",
      SpectrumCollection: "Collection",
      Actor: "Actor",
      Place: "Place",
      Museum: "Museum",
      Location: "Location Information",
      Property: "Property",
      Area: "Landscape or Area",
      ArcheologicalSite: "Archeological Site",
      BuiltEnvironmentSite: "BuiltEnvironment Site",
      Building: "Building",
      OtherSite: "Other Site",
      Project: "Project",
      Inspection: "Inspection",
      LocalMuseum: "Local Museum",
      Statement: "Statement",
      save: "Save",
      cancel: "Cancel",
      confirmCancel: "You have unsaved changes. Do you want to discard them?",
    },
    error: {
      invalidFields: "Field error. Please check and try again",
      objectNoFields: "Object did not contain any fields.",
      objectLoadFailed: "Loading the object failed.",
      viewCrash:
        "An unexpected error occurred. (Refresh browser / Refresh browser cache CTRL+F5)",
      fieldCrash: "Loading field failed.",
      fieldValidation: "Invalid field contents.",
      noValues: "No values found.",
      invalidDate: "Invalid date. (DD.MM.YYYY)",
    },
    warning: {
      resultLimit:
        "Values may be missing from list (too many results). Please narrow search.",
      valueLimitReached: "More values can be found. Too many to display.",
    },
    prompt: {
      removeObject: "Do you want to remove the object?",
      removeAcquisition: `Are you sure you want to remove the Acquisition link?
The object must be linked to an Acquisition, select a new one before saving.`,
      removeAttachment: "Do you want to remove the attachment?",
      removeImage: "Do you want to remove the image?",
      removeLink: "Do you want to remove the link?",
      removeReference: "Do you want to remove the reference?",
      removalReason: "Reason for removal:",
      massEditOverwriteField:
        "Previous values in the selected fields will be overwritten with values entered in the form. Do you want to continue?",
    },
    actions: {
      close: "Close",
      copyObject: "Copy object",
      choose: "Choose",
      save: "Save",
      send: "Send",
      edit: "Edit",
      add: "Add",
      addNew: "Add new",
      link: "Link",
      remove: "Remove",
      search: "Search",
      addToCart: "Add to cart",
      removeFromCart: "Remove from cart",
      preview: "Preview",
      open: "Open",
      create: "Create",
    },
    downloadFile: "Download file",
    downloadVideo: "Download video",
    deleted: "Deleted",
    true: "True",
    targets: "targets",
    false: "False",
    required: "Required",
    loading: "Loading",
    info: "How to use",
    image: "Image",
    object: "Object",
    primaryVersion: "Primary version",
    templates: "Templates",
    roles: "Roles",
    parentCollection: "Parent collection",
    subCollection: "Sub collection",
    primaryNumber: "primary number",
    subNumber: "sub number",
    target: "target",
    validationFailTitle: "Errors in fields",
    helpMessages: "Field help texts",
    objectCount: "Number of objects to create",
    modal: {
      closeWindowPrompt: "Do you want to close the window?",
      saveAndCloseResource: "Save and close",
      saveAndCloseSearch: "Link and close",
      closeWithoutSaving: "Close without saving",
      doNotClose: "Do not close",
      changeAttachment: "Change attachment",
      addAttachment: "Add attachment",
      addImage: "Add image",
      addMedia: "Add media",
      changeImage: "Change image",
      searchAndLink: "Search and link",
      editStatement:
        "Statement already has a PDF-document. Modifications to the fields used in the statement will cause the PDF-document to be deleted. Do you want to save the changes?",
    },
    map: {
      attribution: "Contains data from the National Land Survey of Finland",
      tooltips: {
        tooltips: {
          placeMarker: "Click to place marker",
          firstVertex: "Click to place first vertex",
          continueLine: "Click to continue drawing",
          finishLine: "Click any existing marker to finish",
          finishPoly: "Click first marker to finish",
          finishRect: "Click to finish",
          startCircle: "Click to place circle center",
          finishCircle: "Click to finish circle",
          placeCircleMarker: "Click to place circle marker",
        },
        actions: {
          finish: "Finish",
          cancel: "Cancel",
          removeLastVertex: "Remove Last Vertex",
        },
        buttonTitles: {
          drawMarkerButton: "Draw Marker",
          drawPolyButton: "Draw Polygons",
          drawLineButton: "Draw Polyline",
          drawCircleButton: "Draw Circle",
          drawRectButton: "Draw Rectangle",
          editButton: "Edit Layers",
          dragButton: "Drag Layers",
          cutButton: "Cut Layers",
          deleteButton: "Remove Layers",
          drawCircleMarkerButton: "Draw Circle Marker",
          snappingButton: "Snap dragged marker to other layers and vertices",
          pinningButton: "Pin shared vertices together",
          rotateButton: "Rotate Layers",
        },
      },
      buildingIdLabel: "Building identifiers",
    },
    statement: {
      presetStatementTexts: "Statement preset texts",
      addPresetStamentText: "Add preset statement text",
      noPresetStatementTexts: "No preset statement texts found",
      mailStatement: "Mail statement",
      statementSolverComment: "Solver's comment",
      sendComment: "Send comment",
      massEditRestriction:
        "Statements selected for mass editing are linked to a PDF statement, and its fields cannot be mass edited and are not visible on this form.",
    },
    fieldVisibility: {
      type: "Record type",
      field: "Field",
      changeVisibility: "Change field visibility",
      saveVisibility: "Save changes",
      noFieldChosen: "No fields chosen",
      confirmChangingType: "Discard changes for the current record type?",
    },
    view: {
      AcquisitionInformation: "Acquisition Information",
      Archive: "Archive",
      Art: "Art",
      ImageArchive: "Image Archive",
      CollectionObject: "Collection Object",
      ProceduralUnits: "Procedular Unit",
      SpectrumCollection: "Collection",
      Actor: "Actor",
      Place: "Place",
      Museum: "Museum",
      LocationInformation: "LocationInformation",
      Property: "Property",
      Area: "Landscape or Area",
      ArcheologicalSite: "Archeological Site",
      BuiltEnvironmentSite: "BuiltEnvironment Site",
      Building: "Building",
      OtherSite: "Other Site",
      Project: "Project",
      Inspection: "Inspection",
      LocalMuseum: "Local Museum",
      Statement: "Statement",
    },
    messages: {
      uniquenessValidation: {
        template:
          "${Placeholder-object1}, that has same values in the fields ${Placeholder-fields}, already exists. Do you want to save the ${Placeholder-object2}?",
        fields: {
          Actor: '"person\'s forenames and surname/name/organization"',
          LocationInformation: '"location reference name/number"',
          Property: '"Property ID"',
          Building: '"Building ID"',
        },
        object: {
          Actor1: "An actor",
          Actor2: "actor",
          LocationInformation1: "A location information",
          LocationInformation2: "location information",
          Property1: "A property",
          Property2: "property",
          Building1: "A building",
          Building2: "building",
        },
      },
    },
  },
  sv: {
    error: {
      invalidFields: "Misslyckades med att spara objekt: Kontrollera fälten.",
      objectNoFields: "Objektet innehöll inga fält.",
      objectLoadFailed: "Objektet kunde inte laddas.",
      viewCrash: "Ett kritiskt fel inträffade. (Uppdatera webbläsaren)",
      fieldCrash: "Fältet kunde inte laddas.",
      fieldValidation: "Kontrollera fältet.",
      noValues: "Inga värden hittades.",
      invalidDate: "Ogiltigt datum. (DD.MM.ÅÅÅÅ)",
    },
    warning: {
      resultLimit:
        "Värden kan saknas i listan (för många resultat). Förfina din sökning.",
      valueLimitReached: "Fler värden kan hittas. För många att visa.",
    },
    prompt: {
      removeObject: "Vill du radera objektet?",
      removeAcquisition: `Vill du radera förvärv?
      Objekt måste vara en inköpsvara, välj en ny innan du sparar.`,
      removeAttachment: "Vill du radera bilaga?",
      removeImage: "Vill du radera bilden?",
      removeLink: "Vill du radera länken?",
      removeReference: "Vill du radera referensen?",
      editStatement:
        "Statement har redan ett PDF-dokument. Ändringar av fälten som används i uttalandet kommer att leda till att PDF-dokumentet raderas. Vill du spara ändringarna?",
      massEditOverwriteField:
        "De tidigare värdena ersätts i de valda fälten med de värden som anges i formuläret. Vill du fortsätta?",
    },
    actions: {
      close: "Stänga",
      copyObject: "Kopiera objekt",
      choose: "Välja",
      save: "Spara",
      send: "Skicka",
      edit: "Redigera",
      add: "Lägg till",
      addNew: "Lägg till ny",
      remove: "Radera",
      open: "Öppna",
      search: "Sök",
      addToCart: "Lägg i korgen",
      removeFromCart: "Radera från vagnen",
      preview: "Förhandsvisning",
      create: "Skapa",
      link: "Länkas",
    },
    downloadFile: "Ladda fil",
    downloadVideo: "Ladda video",
    targets: "mål",
    deleted: "Raderade",
    true: "Ja",
    false: "Nej",
    required: "Obligatorisk",
    loading: "Laddar",
    info: "Guide",
    image: "Bild",
    object: "Objekt",
    primaryVersion: "Primär version",
    templates: "Mallar",
    roles: "Roller",
    parentCollection: "Värdsamling",
    subCollection: "Undersamling",
    primaryNumber: "Primärt nummer",
    subNumber: "Undernummer",
    target: "Mål",
    validationFailTitle: "Fel i fält",
    helpMessages: "Fälthjälptexter",
    objectCount: "Antal objekt att skapa",
    modal: {
      closeWindowPrompt: "Vill du stänga fönstret?",
      saveAndCloseResource: "Spara och stäng",
      saveAndCloseSearch: "Länka och stäng",
      closeWithoutSaving: "Stäng utan att spara",
      doNotClose: "Stäng inte",
      changeAttachment: "Ändra bilaga",
      addAttachment: "Bifoga bilaga",
      addImage: "Lägg till bild",
      changeImage: "Ändra bild",
      searchAndLink: "Sök och länka",
    },
    map: {
      attribution: "Innehåller data från Lantmäteriverket",
      tooltips: {
        tooltips: {
          placeMarker: "Klicka för att lägga till ett platsmärke",
          firstVertex: "Klicka för att lägga till en punkt",
          continueLine: "Klicka för att fortsätta rita",
          finishLine: "Klicka på en befintlig markör för att avsluta",
          finishPoly: "Klicka på första markören för att avsluta",
          finishRect: "Klicka för att avsluta",
          startCircle: "Klicka för att lägga till en cirkelpost",
          finishCircle: "Klicka för att avsluta cirkeln",
          placeCircleMarker: "Klicka för att lägga till en cirkelpost",
        },
        actions: {
          finish: "Avsluta",
          cancel: "Annullera",
          removeLastVertex: "Ta bort den sista punkten",
        },
        buttonTitles: {
          drawMarkerButton: "Lägg till ett platsmärke",
          drawPolyButton: "Lägg till en polygon",
          drawLineButton: "Lägg till ett streck",
          drawCircleButton: "Lägg till en cirkel",
          drawRectButton: "Lägg till en rektangel",
          editButton: "Redigera lager",
          dragButton: "Flytta lager",
          cutButton: "Skära lager",
          deleteButton: "Radera lager",
          drawCircleMarkerButton: "Lägg till en cirkelpost",
          snappingButton: "Fäst de platsmärket till andra lager och punkter",
          pinningButton: "kombinera de delade punkten",
        },
      },
      buildingIdLabel: "Byggnadsbeteckningar",
    },
    fieldVisibility: {
      type: "Placeholder",
      field: "Placeholder",
      changeVisibility: "Placeholder",
      saveVisibility: "Placeholder",
      noFieldChosen: "Placeholder",
      confirmChangingType: "Placeholder",
    },
    statement: {
      presetStatementTexts: "Utlåtande förinställda texter",
      addPresetStamentText: "Lägg till förinställd uttalandetext",
      noPresetStatementTexts: "Inga förinställda uttalandetexter hittades.",
      mailStatement: "Mail uttalande",
      statementSolverComment: "Lösares kommentar",
      sendComment: "Skicka kommentar",
      massEditRestriction:
        "Uttalanden som valts för massredigering är länkade till ett PDF-utlåtande, och dess fält kan inte massredigeras och är inte synliga på detta formulär.",
    },
    view: {
      AcquisitionInformation: "Förvärsparti",
      Archive: "Arkiv",
      Art: "Konst",
      ImageArchive: "Bildarkiv",
      CollectionObject: "Objekt samling",
      ProceduralUnits: "Åtgärd",
      SpectrumCollection: "Samling",
      Actor: "Aktör",
      Place: "Plats",
      Museum: "Museum",
      LocationInformation: "Placering",
      Property: "Fastighet",
      Area: "Landskap eller område",
      ArcheologicalSite: "Arkeologiska objekt",
      BuiltEnvironmentSite: "Byggda miljöns objekt",
      Building: "Byggnad",
      OtherSite: "Annat objekt",
      Project: "Projekt",
      Inspection: "Inspektion",
      LocalMuseum: "Lokala museum",
      Statement: "Utlåtande",
    },
    messages: {
      uniquenessValidation: {
        template:
          "${Placeholder-object1}, som har samma innehålls i fälten ${Placeholder-fields}, finns redan. Vill du spara den ${Placeholder-object2}?",
        fields: {
          Actor: '"personens förnamn & efternamn/namn/organisation"',
          LocationInformation: '"placeringens referensnummer eller namn"',
          Property: '"Fastighetsbeteckning"',
          Building: '"Byggnadsbeteckning"',
        },
        object: {
          Actor1: "En äktör",
          Actor2: "aktören",
          LocationInformation1: "En placering",
          LocationInformation2: "placeringen",
        },
      },
    },
  },
});

export const actionSuccesses = {
  fi: {
    helpTextSaved: "Ohjeteksti tallennettu",
    groupAdded: "Ryhmä lisätty onnistuneesti",
    groupDeleted: "Ryhmä poistettu onnistuneesti",
    groupSaved: "Ryhmän tiedot tallennettu onnistuneesti",
    userAdded: "Käyttäjä lisätty onnistuneesti",
    passwordExpiryChanged: "Salasanojen vanhenemisaika vaihdettu",
    userDeleted: "Käyttäjä poistettu onnistuneesti",
    userSaved: "Käyttäjän tiedot tallennettu onnistuneesti",
    userPasswordChanged: "Käyttäjän salasana vaihdettu onnistuneesti",
  },
  en: {
    helpTextSaved: "Help text saved",
    groupAdded: "Group added succesfully",
    groupDeleted: "Group deleted succesfully",
    groupSaved: "Group saved succesfully",
    userAdded: "User added succesfully",
    passwordExpiryChanged: "Password expiry changed succesfully",
    userDeleted: "User deleted succesfully",
    userSaved: "User saved succesfully",
    userPasswordChanged: "Password for user changed succesfully",
  },
  sv: {
    helpTextSaved: "Hjälptexten sparad",
  },
};

export const actionErrors = {
  fi: {
    loadFailed: "Objektin lataaminen epäonnistui: tyhjä",
    identifierInUse: "Päänumero/alanumero on jo käytössä.",
    saveFailed: "Objektin tallentaminen epäonnistui",
    deleteFailed: "Objektin poistaminen epäonnistui",
    deleteLinkFailed: "Linkin poistaminen epäonnistui",
    accessDenied: "Ei oikeuksia objektiin",
    formatNotFound: "Objektin lataaminen epäonnistui (sisäinen virhe)",
    massEditFailed: "Massamuokkaus epäonnistui",
    noAcquisitionTargetType:
      "Tapahtui virhe: Hankintaerän kohdetyyppiä ei löytynyt",
    internalError: "Odottamaton virhe tapahtui",
    couldNotSendMail: "Lausuntoa ei pystytty lähettämään",
    couldNotArchiveStatement: "Lausuntoa ei pystytty käsittelemään",
    couldNotSign: "Lausuntoa ei pystytty allekirjoittamaan.",
    messageToSolverCouldNotBeSent:
      "Ratkaisijalle ei pystytty lähettämään viestiä",
    messageToDemonstratorCouldNotBeSent:
      "Esittelijälle ei pystytty lähettämään viestiä",
  },
  en: {
    loadFailed: "Loading object failed: empty",
    identifierInUse: "Primary number / sub number already in use",
    savefailed: "Saving object failed",
    deleteFailed: "Deleting object failed",
    deleteLinkFailed: "Deleting link failed",
    accessDenied: "Insufficient access to object",
    formatNotFound: "Loading object failed (internal error)",
    massEditfailed: "Mass editing object failed",
    noAcquisitionTargetType: "Error: Acquisition target type not found",
    internalError: "Unexpected error",
    couldNotSendMail: "Could not mail statement",
    couldNotArchiveStatement: "Could not archive statement",
    couldNotSign: "Could not digitally sign statement.",
    messageToSolverCouldNotBeSent: "Could not send message to solver",
    messageToDemonstratorCouldNotBeSent:
      "Could not send message to demonstrator",
  },
  sv: {
    loadFailed: "Att ladda object misslyckades: tom",
    identifierInUse: "Primärt nummer / undernummer används redan",
    savefailed: "Att spara object misslyckades",
    deleteFailed: "Att radera object misslyckades",
    deleteLinkFailed: "Att radera länkan misslyckades",
    accessDenied: "Otillräcklig tillgång till objektet",
    formatNotFound: "Att ladda object misslyckades (internt fel)",
    massEditfailed: "Massredigerings objekt misslyckades",
    noAcquisitionTargetType:
      "Fel: Det gick inte att hitta måltypen för förvärv",
    internalError: "Oväntat fel",
    couldNotSendMail: "Det gick inte att skicka uttalandet",
    couldNotArchiveStatement: "Det gick inte att arkivera uttalandet",
    couldNotSign: "Det gick inte att signera uttalandet digitalt.",
    messageToSolverCouldNotBeSent: "Kunde inte skicka meddelande till lösaren",
    messageToDemonstratorCouldNotBeSent:
      "Kunde inte skicka meddelande till demonstrant",
  },
};

export default React.createContext(LS);
